import { render } from "./APVacations.vue?vue&type=template&id=2c68a6ab"
import script from "./APVacations.vue?vue&type=script&lang=js"
export * from "./APVacations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__